import './RouteBlock.scss'

import React from 'react'
import {LinkType, WysiwygType} from '../../types'
import {useTranslation} from '../../util/i18n'
import {style} from '../../util/style'
import {Theme} from '../Theme'
import {Icon} from '../ui/Icon'
import {MarkedTitle} from '../ui/MarkedTitle'
import {Block} from './Blocks'

const styles = style('routeblock', ['item'])

export type RouteBlockType = {
	title?: string
	text?: WysiwygType
	items: Array<RouteBlockItemType>
	button?: LinkType
}

type RouteBlockItemType = {
	kilometers: number
	activity: 'walking' | 'biking'
}

export const RouteBlock: React.FC<
	RouteBlockType & {container?: boolean; sidebar?: boolean}
> = ({container, sidebar, title, text, items, button}) => {
	if (!items || items.length === 0) return null
	const t = useTranslation('events').route

	return (
		<Block className={styles()} container={container} sidebar={sidebar}>
			<div className={styles('block').mod({button: button && button.url})}>
				<MarkedTitle title={title || t.title} direction="left" as="h2" />
				{text && (
					<div className={styles('block-text')}>
						<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
					</div>
				)}
				{items && items.length > 0 && (
					<div className={styles('block-items')}>
						{items.map((item, i) => (
							<RouteBlockItem key={i} {...item} />
						))}
					</div>
				)}
				{button && button.url && (
					<div className={styles('block-button')}>
						<Theme.Button to={button.url} withIcon="arrow">
							{button.description || button.title}
						</Theme.Button>
					</div>
				)}
			</div>
		</Block>
	)
}

const RouteBlockItem: React.FC<RouteBlockItemType> = ({
	kilometers = 0,
	activity
}) => {
	if (!activity) return null

	return (
		<div className={styles.item()}>
			<span className={styles.item('icon')}>
				<Icon icon={activity} />
			</span>
			<p className={styles.item('activity')}>
				{kilometers + ' km ' + switchActivity(activity)}
			</p>
		</div>
	)
}

function switchActivity(activity) {
	const t = useTranslation('events').route

	switch (activity) {
		case 'walking':
			return t.walking
		case 'biking':
			return t.biking
	}
}
